import React, { useState } from 'react';
import PropTypes from 'prop-types';
import api from 'helpers/api';
import classNames from 'classnames';
import {
  Card,
  Button,
  Row,
  Col,
  Modal,
  Tabs,
  Tab,
  Table,
  Spinner
} from 'react-bootstrap';
import KanbanColumnHeader from './KanbanColumnHeader';
import SubtleBadge from 'components/common/SubtleBadge';
import SubtleBadgeWhite from 'components/common/SubtleBadgeWhite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { faDownload, faFileImport } from '@fortawesome/free-solid-svg-icons';
import { DownloadHS, Download, newDowload } from 'helpers/utils';
import { getOperacaoLocal } from 'helpers/auth';
import PageHeader from 'components/common/PageHeader';
import ProcessTimeLine from '../process-details/ProcessTimeLine';
import ProcessTimeLineFrete from '../process-details/ProcessTimeLineFrete';
import ProcessFollow from '../process-details/ProcessFollow';
import CustoItens from '../process-details/CustoItens';
var jszip = require('jszip');
var saveAs = require('file-saver');
import * as XLSX from 'xlsx';
import { useAppContext } from 'Main';
import TrackingMap from '../process-details/TrackingMap';

const KanbanCard = ({ colorHeader, dados, title, ordem }) => {
  const {
    config: { theme }
  } = useAppContext();
  const [getProcesso, setProcesso] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const [existeArquivos, setExisteArquivos] = useState(false);
  const [existeCusto, setExisteCusto] = useState(false);
  const [existeCustoItens, setExisteCustoItens] = useState(false);
  const [modalShowArquivo, setModalShowArquivo] = React.useState(false);
  const [modalShowCusto, setModalShowCusto] = React.useState(false);
  const [modalShowCustoiLog, setModalShowCustoiLog] = React.useState(false);
  const [isDownloading, setisDownloading] = React.useState(false);
  const [isExpo, setExpo] = React.useState(false);
  const [isLoadingFile, setLoadingFile] = React.useState(false);
  const [possuiTracking, setPossuiTracking] = useState(false);
  const [showModalTracking, setShowModalTracking] = useState(false);
  const [modalShowCustoItensiLog, setModalShowCustoItensiLog] =
    React.useState(false);
  const [showModal, setShowModal] = useState(false);
  const [operacao, setOperacao] = React.useState('');
  const [totalGeralCustos, setTotalGeralCustos] = React.useState('');
  const [totalGeralRecebido, setTotalGeralRecebido] = React.useState('');
  const [dataProcesso, setDataProcesso] = useState([]);
  const [dataCustoItens, setDataCustoItens] = useState([]);
  const [dataCustoSubItens, setDataCustoSubItens] = useState([]);
  const [dataFollowUp, setDataFollowUp] = useState([]);
  const [dataFiles, setDataFiles] = useState([]);
  const [dataCusto, setDataCusto] = useState([]);
  const [custoTotal, setCustoTotal] = useState([]);
  const [dataCustoTotal, setDataCustoTotal] = useState([]);
  const [dadosTransbordo, setDataTransbordo] = useState([]);
  const [dataTracking, setDataTracking] = useState([]);
  const [dataTrackingWorld, setDataTrackingWorld] = useState([]);
  const [selectAll, setSelectAll] = useState(true);
  const [selectedColumns, setSelectedColumns] = useState({
    AdicaoNumero: true,
    OrdemItem: true,
    Codigo: true,
    Descricao: true,
    Ncm: true,
    Unidade: true,
    Quantidade: true,
    pesoliquidounitario: true,
    PesoLiquido: true,
    PrecoUnitario: true,
    FobMEValor: true,
    razaosocial_emp: true,
    Frete: true,
    Seguro: true,
    CIFValor: true,
    iialiquota: true,
    IIBase: true,
    IIValor: true,
    ipialiquota: true,
    ipiBase: true,
    IPI: true,
    pisaliquota: true,
    pisbase: true,
    pis: true,
    confinsaliquota: true,
    confinsBase: true,
    COFINS: true,
    TaxaSiscomex: true,
    icmsaliquota: true
  });

  const handleColumnChange = column => {
    setSelectedColumns(prev => {
      const updatedColumns = {
        ...prev,
        [column]: !prev[column]
      };

      // Verifica se ainda há colunas selecionadas
      const anySelected = Object.values(updatedColumns).some(
        selected => selected
      );
      setSelectAll(!anySelected); // Atualiza o estado de "Selecionar Todos"

      return updatedColumns;
    });
  };

  const columnLabels = {
    AdicaoNumero: 'Adicao Número',
    OrdemItem: 'Ordem',
    Codigo: 'Código',
    Descricao: 'Descrição',
    Ncm: 'NCM',
    Unidade: 'Unidade',
    Quantidade: 'Quantidade',
    pesoliquidounitario: 'P. Líq. Unit.',
    PesoLiquido: 'P. Líquido',
    PrecoUnitario: 'Preço Unitário',
    FobMEValor: 'MERCADORIA',
    razaosocial_emp: 'EXPORTADOR',
    Frete: 'FRETE',
    Seguro: 'SEGURO',
    CIFValor: 'VALOR ADUANEIRO',
    iialiquota: '% II',
    IIBase: 'BASE II',
    IIValor: 'II',
    ipialiquota: '% IPI',
    ipiBase: 'BASE IPI',
    IPI: 'IPI',
    pisaliquota: '% PIS',
    pisbase: 'BASE PIS',
    pis: 'PIS',
    confinsaliquota: '% COFINS',
    confinsBase: 'BASE COFINS',
    COFINS: 'COFINS',
    TaxaSiscomex: 'TAXA SISCOMEX',
    icmsaliquota: '% ICMS'
  };

  const exportToExcel = () => {
    const dados = combineData(dataCustoItens, dataCustoSubItens);
    const columnsToExport = Object.keys(selectedColumns).filter(
      col => selectedColumns[col]
    );

    const exportData = dados.map(item => {
      return columnsToExport.reduce((obj, key) => {
        obj[columnLabels[key]] = item[key];
        return obj;
      }, {});
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

    // Gera um arquivo Excel
    XLSX.writeFile(workbook, 'custos.xlsx');
  };

  const handleSelectAllChange = event => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setSelectedColumns(prev => {
      const updatedColumns = {};
      Object.keys(prev).forEach(key => {
        updatedColumns[key] = isChecked; // Define todas as colunas para o estado do checkbox
      });
      return updatedColumns;
    });
  };

  function combineData(custo, subCusto) {
    const combinedData = [];

    custo.forEach(c => {
      const subs = subCusto.filter(sc => sc.AdicaoNumero === c.AdicaoNumero);
      if (subs.length > 0) {
        subs.forEach(sub => {
          combinedData.push({ ...c, ...sub }); // Combina os dados
        });
      } else {
        // Se não houver subCusto correspondente, ainda assim adiciona o custo
        combinedData.push({ ...c, Codigo: '', Descricao: '' }); // Campos do subCusto vazios
      }
    });

    return combinedData;
  }

  const parseDateString = dateString => {
    const [day, month, year] = dateString.split('/'); // Exemplo: "31/12/2023"
    return new Date(`${year}-${month}-${day}`); // Converte para YYYY-MM-DD
  };

  const handleClickOpenFollowUp = id => {
    const GetData = async () => {
      setIsLoading(true);
      setOperacao(getOperacaoLocal()[0]);
      if (id !== '') {
        if (getOperacaoLocal === 'EXPORTAÇÃO') {
          setExpo(true);
          setIsLoading(false);
        }
        const getProcess = async () => {
          const result = await api.get(`/api/follownewpg/I&${id}`);
          if (result.data.cabecalho[0].situacao_viagem > 0) {
            setPossuiTracking(true);
            if (result.data.mapa.length > 0) {
              setDataTrackingWorld(result.data.mapa[0].dados);
            }
          } else {
            setPossuiTracking(false);
          }
          setDataProcesso(result.data.cabecalho);
          setDataFollowUp(result.data.followup);
          setCustoTotal(0);
          setIsLoading(false);
          // if (sigla === 'F') {
          //   setDataTracking(result.data.tracking);
          //   setDataTransbordo(result.data.tracking[0].transbordo);
          //   const resultFile = await api.get(`/api/hs/arquivos/${id}`);
          //   setDataFiles(resultFile.data.result.recordset);
          //   if (resultFile.data.result.recordset.length > 0) {
          //     setExisteArquivos(true);
          //   }

          //   const resultCustos = await api.get(`/api/hs/custo/${id}`);
          //   setDataCusto(resultCustos.data.result);
          //   setCustoTotal(resultCustos.data.total[0].ValorTotal);
          //   if (resultCustos.data.total[0].ValorTotal !== null) {
          //     setExisteCusto(true);
          //   }
          //   // setRealizouConsulta(false);
          // }
          // if (sigla !== 'T' && sigla !== 'F') {
          const resultArq = await api.get(`/api/empresas/arquivos/${id}`);
          if (resultArq.data.result.length > 0) {
            setExisteArquivos(true);
            setDataFiles(resultArq.data.result);
          }
          if (getOperacaoLocal() === 'IMPORTAÇÃO') {
            const resultCustos = await api.get(`/api/empresas/custosnew/${id}`);
            if (resultCustos.data.result.length > 0) {
              setDataCusto(resultCustos.data.result);
              setExisteCusto(true);
              setDataCustoTotal(resultCustos.data.totais);

              if (resultCustos.data.totais.length > 0) {
                setTotalGeralCustos(resultCustos.data.totalCusto[0].total);
                setTotalGeralRecebido(resultCustos.data.totalRecebido[0].total);
              }
            } else {
              setExisteCusto(false);
            }
            // }

            const resultCustosItens = await api.get(
              `/api/empresas/custositens/${id}`
            );
            if (resultCustosItens.data.result.length > 0) {
              setExisteCustoItens(true);
              setDataCustoItens(resultCustosItens.data.result);
              setDataCustoSubItens(resultCustosItens.data.sub);
            }

            setIsLoading(false);
          }
        };
        getProcess();
        // getProcesso;
      }
    };

    setShowKanban(true);
    GetData();
  };

  const getUrlFile = async id => {
    if (operacao[0] === 'A') {
      const result = await api.get(`/api/hs/arquivoURL/${id}`);
      DownloadHS(result.data.result, 'Teste.pdf');
    } else if (
      getOperacaoLocal() === 'IMPORTAÇÃO' ||
      getOperacaoLocal() === 'EXPORTAÇÃO'
    ) {
      const result = await api.get(`/api/empresas/file/${id}`);
      Download(
        result.data.result[0].File.data,
        'application/' +
          result.data.result[0].FileName.substring(
            result.data.result[0].FileName.indexOf('.') + 1
          ),
        result.data.result[0].FileName
      );
      // } else if (operacao[0] === 'T') {
      //   setisDownloading(true);
      //   const result = await api.get(`/api/empresas/arquivoURL/${id}`);

      //   let a = document.createElement('a');
      //   a.href = result.data.result.url;
      //   a.download = result.data.result.filename;
      //   setisDownloading(false);
      //   a.click();
    }
  };

  const FileDownloadFilesBlob = async (dataFile, qual) => {
    setLoadingFile(true);
    var zip = new jszip();
    dataFile.forEach(async element => {
      if (qual === 'Todos') {
        if (element['Folder'] === 'Processo' || element['Folder'] === null) {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('processo');
          img.file(element['FileName'], blob);
        }
        if (element['Folder'] === 'Financeiro') {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('financeiro');
          img.file(element['FileName'], blob);
        }
      } else if (qual === 'Processo') {
        if (element['Folder'] === 'Processo' || element['Folder'] === null) {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('processo');
          img.file(element['FileName'], blob);
        }
      } else if (qual === 'Financeiro') {
        if (element['Folder'] === 'Financeiro') {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('financeiro');
          img.file(element['FileName'], blob);
        }
      }
    });

    zip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, 'arquivos.zip');
      setLoadingFile(false);
    });
  };

  const getAll = async id => {
    const result = await api.get('/api/empresas/file/' + id);
    var blob = newDowload(
      result.data.result[0].File.data,
      'application/' +
        result.data.result[0].FileName.substring(
          result.data.result[0].FileName.indexOf('.') + 1
        ),
      result.data.result[0].FileName
    );
    return blob;
  };

  return (
    <div className={classNames('kanban-column')}>
      <KanbanColumnHeader
        colorHeader={colorHeader}
        id={ordem}
        title={title}
        itemCount={dados.length}
      />

      <div id={`container-1`} className="kanban-items-container scrollbar">
        {dados.map(task => {
          return (
            <div className="kanban-item" key={task.id}>
              <Card
                className="kanban-item-card hover-actions-trigger"
                onClick={() => {
                  handleClickOpenFollowUp(task.id);
                  setProcesso(`${task.name}`);
                }}
              >
                <Card.Body>
                  <div className="mb-2">
                    <Row className="flex-between-center ">
                      <Col
                        xs={4}
                        sm="auto"
                        className="d-flex align-items-center pe-2"
                      >
                        <SubtleBadge
                          pill
                          bg={classNames({
                            danger: task.processo !== ''
                          })}
                          className="d-flex flex-center"
                        >
                          <p
                            className="mb-0 fw-medium font-sans-serif"
                            dangerouslySetInnerHTML={{
                              __html: task.processo
                            }}
                          />
                        </SubtleBadge>
                        <SubtleBadge
                          pill
                          bg={classNames({
                            primary:
                              task.modalidade === 'AÉREO' ||
                              task.modalidade === 'AIRFREIGHT' ||
                              task.modalidade === 'Aereo',
                            info:
                              task.modalidade === 'RODOVIÁRIO' ||
                              task.modalidade === 'Rodoviário' ||
                              task.modalidade === 'RODOVIARIO',
                            success:
                              task.modalidade === 'Marítimo' ||
                              task.modalidade === 'Maritimo' ||
                              task.modalidade === 'MARITIMA' ||
                              task.modalidade === 'BREAK BULK' ||
                              task.modalidade === 'MARÍTIMO (LCL)' ||
                              task.modalidade === 'MARÍTIMO (FCL)'
                          })}
                          className="d-flex flex-center"
                        >
                          <FontAwesomeIcon
                            icon={classNames({
                              plane:
                                task.modalidade === 'AÉREO' ||
                                task.modalidade === 'AIRFREIGHT' ||
                                task.modalidade === 'Aereo',
                              truck:
                                task.modalidade === 'RODOVIÁRIO' ||
                                task.modalidade === 'Rodoviário' ||
                                task.modalidade === 'RODOVIARIO',
                              ship:
                                task.modalidade === 'Marítimo' ||
                                task.modalidade === 'Maritimo' ||
                                task.modalidade === 'MARITIMA' ||
                                task.modalidade === 'BREAK BULK' ||
                                task.modalidade === 'MARÍTIMO (LCL)' ||
                                task.modalidade === 'MARÍTIMO (FCL)'
                            })}
                            transform="shrink-1"
                            size="lg"
                          />
                          &nbsp;
                          {task.modal_text}
                        </SubtleBadge>
                      </Col>
                      <Col xs={5} sm="auto" className="pe-2 ">
                        <SubtleBadge
                          pill
                          bg={classNames({
                            warning: task.tipo !== ''
                          })}
                          className="d-flex flex-center"
                        >
                          <p
                            className="mb-0 fw-medium font-sans-serif"
                            style={{
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis'
                            }}
                            dangerouslySetInnerHTML={{
                              __html: task.tipo
                            }}
                          />
                        </SubtleBadge>
                      </Col>
                    </Row>
                    <Row className="flex-between-center ">
                      <Col
                        xs={4}
                        sm="auto"
                        className="d-flex align-items-center pe-0"
                      >
                        {theme === 'light' || theme === 'auto' ? (
                          <>
                            <SubtleBadge
                              pill
                              bg={classNames({
                                light: task.referencia !== ''
                              })}
                              className="d-flex flex-center"
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif"
                                dangerouslySetInnerHTML={{
                                  __html: task.referencia
                                }}
                              />
                            </SubtleBadge>
                          </>
                        ) : (
                          <>
                            <SubtleBadgeWhite
                              pill
                              bg={classNames({
                                dark: task.referencia !== ''
                              })}
                              className="d-flex flex-center"
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif"
                                dangerouslySetInnerHTML={{
                                  __html: task.referencia
                                }}
                              />
                            </SubtleBadgeWhite>
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row className="overflow-hidden textOverflow-ellipsis hover-overflow-visible mt-1">
                      <Col
                        xs={4}
                        sm="auto"
                        className="d-flex align-items-start pe-0"
                      >
                        {theme === 'light' || theme === 'auto' ? (
                          <>
                            <SubtleBadge
                              pill
                              bg={classNames({
                                light: task.exportador !== ''
                              })}
                              className="d-flex flex-center"
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif"
                                dangerouslySetInnerHTML={{
                                  __html: task.exportador
                                }}
                              />
                            </SubtleBadge>
                          </>
                        ) : (
                          <>
                            <SubtleBadgeWhite
                              pill
                              className="d-flex flex-center"
                              style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                color: 'inherit',
                                display: 'inline-block' // Tente definir isso
                              }}
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif"
                                dangerouslySetInnerHTML={{
                                  __html: task.exportador
                                }}
                              />
                            </SubtleBadgeWhite>
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row className="flex-between-center mt-1">
                      <Col
                        xs={4}
                        sm="auto"
                        className="d-flex align-items-center pe-0"
                      >
                        <SubtleBadge
                          pill
                          bg={classNames({
                            success:
                              task.dataembarque !== '00/00/0000' &&
                              task.dataembarque !== '' &&
                              task.dataembarque !== null,
                            info:
                              task.previsaoembarque !== null &&
                              task.previsaoembarque !== '00/00/0000'
                          })}
                          className="d-flex flex-center w-100"
                        >
                          <p
                            className="mb-0 fw-medium font-sans-serif stretched-link"
                            dangerouslySetInnerHTML={{
                              __html:
                                task.dataembarque !== '00/00/0000' &&
                                task.dataembarque !== '' &&
                                task.dataembarque !== null
                                  ? `Conf. Embarque `
                                  : task.previsaoembarque !== '00/00/0000' &&
                                    task.previsaoembarque !== null
                                  ? `Prev. Embarque `
                                  : ''
                            }}
                          />
                        </SubtleBadge>
                      </Col>
                      <Col
                        xs={4}
                        sm="auto"
                        className="d-flex align-items-center pe-0"
                      >
                        <SubtleBadge
                          pill
                          bg={classNames({
                            success:
                              task.datachegada !== '00/00/0000' &&
                              task.datachegada !== '' &&
                              task.datachegada !== null,
                            info:
                              task.previsaochegada !== '' &&
                              task.previsaochegada !== '00/00/0000' &&
                              task.previsaochegada !== null
                          })}
                          className="d-flex flex-center w-100"
                        >
                          <p
                            className="mb-0 fw-medium font-sans-serif stretched-link"
                            dangerouslySetInnerHTML={{
                              __html:
                                task.datachegada !== '00/00/0000' &&
                                task.datachegada !== '' &&
                                task.datachegada !== null
                                  ? `Conf. Chegada `
                                  : task.previsaochegada !== '00/00/0000' &&
                                    task.previsaochegada !== '' &&
                                    task.previsaochegada !== null
                                  ? `Prev. Chegada `
                                  : ''
                            }}
                          />
                        </SubtleBadge>
                      </Col>
                    </Row>
                    <Row className="flex-between-center mt-1">
                      <Col
                        xs={4}
                        sm="auto"
                        className="d-flex align-items-center pe-0"
                      >
                        {theme === 'light' || theme === 'auto' ? (
                          <>
                            <SubtleBadge
                              pill
                              bg={classNames({
                                light: task.dataembarque !== ''
                              })}
                              className="d-flex flex-center"
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif stretched-link"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    task.dataembarque !== '' &&
                                    task.dataembarque !== null &&
                                    task.dataembarque !== '00/00/0000'
                                      ? `${task.dataembarque} `
                                      : task.previsaoembarque !== null &&
                                        task.previsaoembarque !== '00/00/0000'
                                      ? `${task.previsaoembarque} `
                                      : ''
                                }}
                              />
                            </SubtleBadge>
                          </>
                        ) : (
                          <>
                            <SubtleBadgeWhite
                              pill
                              bg={classNames({
                                dark: task.dataembarque !== ''
                              })}
                              className="d-flex flex-center"
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif stretched-link"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    task.dataembarque !== '' &&
                                    task.dataembarque !== null &&
                                    task.dataembarque !== '00/00/0000'
                                      ? `${task.dataembarque} `
                                      : task.previsaoembarque !== null &&
                                        task.previsaoembarque !== '00/00/0000'
                                      ? `${task.previsaoembarque} `
                                      : ''
                                }}
                              />
                            </SubtleBadgeWhite>
                          </>
                        )}
                      </Col>
                      <Col
                        xs={4}
                        sm="auto"
                        className="d-flex align-items-center pe-0"
                      >
                        {theme === 'light' || theme === 'auto' ? (
                          <>
                            <SubtleBadge
                              pill
                              bg={classNames({
                                light: task.datachegada !== ''
                              })}
                              className="d-flex flex-center"
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif stretched-link"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    task.datachegada !== '' &&
                                    task.datachegada !== '00/00/0000' &&
                                    task.datachegada != null
                                      ? `${task.datachegada} `
                                      : task.previsaochegada !== '' &&
                                        task.previsaochegada !== '00/00/0000' &&
                                        task.previsaochegada != null
                                      ? `${task.previsaochegada} `
                                      : ''
                                }}
                              />
                            </SubtleBadge>
                          </>
                        ) : (
                          <>
                            <SubtleBadgeWhite
                              pill
                              bg={classNames({
                                dark: task.datachegada !== ''
                              })}
                              className="d-flex flex-center"
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif stretched-link"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    task.datachegada !== '' &&
                                    task.datachegada !== '00/00/0000' &&
                                    task.datachegada != null
                                      ? `${task.datachegada} `
                                      : task.previsaochegada !== '' &&
                                        task.previsaochegada !== '00/00/0000' &&
                                        task.previsaochegada != null
                                      ? `${task.previsaochegada} `
                                      : ''
                                }}
                              />
                            </SubtleBadgeWhite>
                          </>
                        )}
                      </Col>
                    </Row>
                    <Row className="flex-between-center mt-1">
                      <Col
                        xs={4}
                        sm="auto"
                        className="d-flex align-items-center pe-0"
                      >
                        {theme === 'light' || theme === 'auto' ? (
                          <>
                            <SubtleBadge
                              pill
                              bg={classNames({
                                light: task.follow !== ''
                              })}
                              className="d-flex flex-center"
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif text-wrap text-start" // Classe para alinhamento à esquerda
                                style={{
                                  overflowWrap: 'break-word',
                                  whiteSpace: 'normal',
                                  textAlign: 'left'
                                }} // Estilo adicional para alinhamento
                                dangerouslySetInnerHTML={{
                                  __html: task.follow
                                }}
                              />
                            </SubtleBadge>
                          </>
                        ) : (
                          <>
                            <SubtleBadgeWhite
                              pill
                              bg={classNames({
                                dark: task.follow !== ''
                              })}
                              className="d-flex flex-center"
                            >
                              <p
                                className="mb-0 fw-medium font-sans-serif text-wrap text-start" // Classe para alinhamento à esquerda
                                style={{
                                  overflowWrap: 'break-word',
                                  whiteSpace: 'normal',
                                  textAlign: 'left'
                                }} // Estilo adicional para alinhamento
                                dangerouslySetInnerHTML={{
                                  __html: task.follow
                                }}
                              />
                            </SubtleBadgeWhite>
                          </>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Card.Body>
              </Card>
            </div>
          );
        })}
      </div>
      <Modal
        show={showKanban}
        onHide={() => setShowKanban(false)}
        size="xl"
        centered
      >
        {isLoading ? (
          <>
            <Flex justifyContent="center">
              <div className="p-2">
                <Spinner />
                <span> Aguarde carregando ...</span>
              </div>
            </Flex>
          </>
        ) : (
          <Modal.Body className="p-0">
            {dataProcesso.map(row => {
              return (
                <>
                  <PageHeader
                    title={`PROCESSO: ${row.processo}`}
                    titleTag="h5"
                    className="mb-1"
                  >
                    {' '}
                    <div className="">
                      <div className="row align-items-start mt-2">
                        <div className="col-6 d-inline-flex">
                          <h6>{isExpo ? 'Importador:' : 'Exportador:'}</h6>
                          <h6 className="fw-normal">
                            &nbsp;
                            {isExpo ? row.importador : row.exportador}
                          </h6>
                        </div>
                      </div>
                      {operacao[0] === 'A' ? (
                        <>
                          <div className="row align-items-center">
                            <div className="col-6 d-inline-flex">
                              <h6>Importador: </h6>
                              <h6 className="fw-normal">
                                &nbsp;
                                {row.IMPORTADOR}
                              </h6>
                            </div>
                            <div className="col-2 d-inline-flex">
                              <h6>Modalidade: </h6>
                              <h6 className="fw-normal">
                                &nbsp;
                                {row.MODALIDADE}
                              </h6>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="row align-items-center">
                            <div className="col-6 d-inline-flex">
                              <h6>Ref. Cliente: </h6>
                              <h6
                                className="fw-normal"
                                style={{
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                &nbsp;
                                {row.referencia}
                              </h6>
                            </div>
                            <div className="col-2 d-inline-flex">
                              <h6>Fatura: </h6>
                              <h6 className="fw-normal">&nbsp;{row.fatura}</h6>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="row align-items-end">
                        {operacao[0] === 'A' ? (
                          <>
                            <div className="col-6 d-inline-flex">
                              <h6>Ref. Cliente: </h6>
                              <h6 className="fw-normal">
                                &nbsp;{row.REFERENCIA}
                              </h6>
                            </div>
                            <div className="col-2 d-inline-flex">
                              <h6>
                                {operacao[0] === 'A' &&
                                row.MODALIDADE === 'Aereo'
                                  ? 'HAWB:'
                                  : operacao[0] === 'A' &&
                                    row.MODALIDADE === 'Maritimo'
                                  ? 'HBL:'
                                  : 'Conhecimento:'}{' '}
                              </h6>
                              <h6 className="fw-normal">
                                &nbsp;
                                {row.CONHECIMENTO !== 'null'
                                  ? row.CONHECIMENTO
                                  : ''}
                              </h6>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-6 d-inline-flex">
                              <h6>Modalidade: </h6>
                              <h6 className="fw-normal">
                                &nbsp;{row.modalidade}
                              </h6>
                            </div>
                            <div className="col-2 d-inline-flex">
                              <h6>
                                {operacao[0] === 'A' &&
                                row.modalidade === 'Aereo'
                                  ? 'HAWB:'
                                  : 'Conhecimento:'}{' '}
                              </h6>
                              <h6 className="fw-normal">
                                &nbsp;
                                {row.conhecimento !== 'null'
                                  ? row.conhecimento
                                  : ''}
                              </h6>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="row align-items-end">
                        {operacao[0] === 'A' ? (
                          <>
                            <div className="col-6 d-inline-flex">
                              <h6>Viagem </h6>
                              <h6 className="fw-normal">
                                &nbsp;{row.Viagem !== 'null' ? row.Viagem : ''}
                              </h6>
                            </div>
                            <div className="col-2 d-inline-flex">
                              <h6>Reserva: </h6>
                              <h6 className="fw-normal">
                                &nbsp;
                                {row.Numero_Controle !== 'null'
                                  ? row.Numero_Controle
                                  : ''}
                              </h6>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-6 d-inline-flex">
                              <h6>{isExpo ? 'DUE:' : 'DI:'} </h6>
                              <h6 className="fw-normal">
                                &nbsp;{row.DI !== 'null' ? row.di : ''} &nbsp; -
                                &nbsp;
                                {row.pditipo !== '' ? row.pditipo : ''}
                              </h6>
                            </div>
                            <div className="col-2 d-inline-flex">
                              <h6>{isExpo ? 'Averbação:' : 'Registro:'} </h6>
                              <h6 className="fw-normal">
                                &nbsp;
                                {isExpo ? (
                                  <>
                                    {row.dt_averbacao !== '00/00/0000'
                                      ? row.dt_averbacao
                                      : ''}
                                  </>
                                ) : (
                                  <>
                                    {row.dt_di_registro !== '00/00/0000'
                                      ? row.dt_di_registro
                                      : ''}
                                  </>
                                )}
                              </h6>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="row align-items-end">
                        {operacao[0] === 'A' ? (
                          <>
                            <div className="col-6 d-inline-flex">
                              <h6>Incoterm: </h6>
                              <h6 className="fw-normal">
                                &nbsp;
                                {row.INCOTERM !== 'null' ? row.INCOTERM : ''}
                              </h6>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-6 d-inline-flex">
                              <h6>Canal: </h6>
                              <h6 className="fw-normal">
                                &nbsp;{row.canal !== 'null' ? row.canal : ''}
                              </h6>
                            </div>
                            <div className="col-2 d-inline-flex">
                              <h6>Incoterm: </h6>
                              <h6 className="fw-normal">
                                &nbsp;
                                {row.incoterm !== 'null' ? row.incoterm : ''}
                              </h6>
                            </div>
                          </>
                        )}
                      </div>
                      {/* <div className="row align-items-end">
                                    <div className="col-6 d-inline-flex">
                                      <h6>Peso Bruto: </h6>
                                      <h6 className="fw-normal">&nbsp;{row.peso_bruto_pro}</h6>
                                    </div>
                                    <div className="col-2 d-inline-flex">
                                      <h6>Cubagem: </h6>
                                      <h6 className="fw-normal">&nbsp;{row.cubagem}</h6>
                                    </div>
                                  </div> */}
                    </div>
                    {existeArquivos ? (
                      <>
                        <Button
                          className="me-1 mb-1 bc-"
                          size="sm"
                          onClick={() => setModalShowArquivo(true)}
                        >
                          Arquivos
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          className="me-1 mb-1 bc-"
                          size="sm"
                          disabled
                          onClick={() => setModalShowArquivo(true)}
                        >
                          Arquivos
                        </Button>
                      </>
                    )}
                    {possuiTracking ? (
                      <>
                        <Button
                          className="me-1 mb-1 bc-"
                          size="sm"
                          onClick={() => setShowModalTracking(true)}
                        >
                          Tracking
                        </Button>
                      </>
                    ) : (
                      <></>
                    )}
                    {operacao !== 'E' ? (
                      <>
                        {existeCusto ? (
                          <>
                            <Button
                              className="me-1 mb-1 bc-"
                              size="sm"
                              onClick={() =>
                                operacao[0] === 'A'
                                  ? setModalShowCusto(true)
                                  : setModalShowCustoiLog(true)
                              }
                            >
                              {operacao[0] === 'A'
                                ? 'Numerário'
                                : 'Custo Nacionalização'}
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              className="me-1 mb-1 bc-"
                              size="sm"
                              disabled
                              onClick={() => setModalShowCusto(true)}
                            >
                              {operacao[0] === 'A'
                                ? 'Numerário'
                                : 'Custo Nacionalização'}
                            </Button>
                          </>
                        )}
                        {operacao[0] === 'A' ? (
                          <></>
                        ) : (
                          <>
                            {existeCustoItens ? (
                              <>
                                <Button
                                  className="me-1 mb-1 bc-"
                                  size="sm"
                                  onClick={() =>
                                    setModalShowCustoItensiLog(true)
                                  }
                                >
                                  Custo Nacionalização por Item
                                </Button>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </PageHeader>
                  {/*Modal Arquivo*/}
                  <Modal
                    show={modalShowArquivo}
                    onHide={() => setModalShowArquivo(false)}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <Modal.Title
                        id="contained-modal-title-vcenter"
                        style={{ fontSize: '0.875rem' }}
                      >
                        Arquivos
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <>
                        <IconButton
                          size="sm"
                          alt="Baixar Arquivo"
                          aria-label="Baixar Arquivo"
                          onClick={() =>
                            FileDownloadFilesBlob(dataFiles, 'Todos')
                          }
                          style={{
                            marginLeft: 'auto',
                            marginRight: 'auto'
                          }}
                        >
                          Baixar Todos(Processo / Financeiro)
                          <FontAwesomeIcon icon={faDownload} />
                        </IconButton>
                        {isLoadingFile ? (
                          <>
                            <Spinner style={{ color: 'black' }} size="0.2rem" />

                            <span
                              style={{ color: 'black', fontSize: '0.75rem' }}
                            >
                              Aguarde....
                            </span>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                      <Tabs
                        defaultActiveKey="processo"
                        id="uncontrolled-tab-example"
                      >
                        <Tab
                          eventKey="processo"
                          title="Processo"
                          className="p-3"
                          style={{ fontSize: '0.875rem' }}
                        >
                          <Table size="sm">
                            <thead>
                              <tr>
                                <th style={{ fontSize: '0.875rem' }}>
                                  Data
                                  {isDownloading ? (
                                    <>
                                      <Spinner
                                        size="1rem"
                                        style={{ color: 'black' }}
                                      />
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </th>
                                <th style={{ fontSize: '0.875rem' }}>
                                  Descricao
                                </th>
                                <th
                                  style={{
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  Download
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {dataFiles
                                .filter(arq => arq.Folder !== 'Financeiro')
                                .sort(
                                  (a, b) =>
                                    parseDateString(b.data) -
                                    parseDateString(a.data)
                                )
                                .map(row => {
                                  return (
                                    <>
                                      <tr key={row.iFileSystemID}>
                                        <td style={{ fontSize: '0.75rem' }}>
                                          {row.data}
                                        </td>
                                        <td style={{ fontSize: '0.75rem' }}>
                                          {row.FileName}
                                        </td>
                                        <td
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            fontSize: '0.75rem'
                                          }}
                                        >
                                          {' '}
                                          <IconButton
                                            size="sm"
                                            alt="Baixar Arquivo"
                                            aria-label="Baixar Arquivo"
                                            onClick={() =>
                                              getUrlFile(
                                                getOperacaoLocal() ===
                                                  'IMPORTAÇÃO' ||
                                                  getOperacaoLocal() ===
                                                    'EXPORTAÇÃO'
                                                  ? row.iFileSystemID
                                                  : // : operacao[0] === 'T'
                                                    //   ? `${row.DCM_COD}&${row.ADF_COD_SEQ}&${row.FIL_COD}`
                                                    row.IdLogistica_House
                                              )
                                            }
                                            style={{
                                              marginLeft: 'auto',
                                              marginRight: 'auto'
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              icon={faDownload}
                                            />
                                          </IconButton>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                            </tbody>
                          </Table>
                        </Tab>
                        <Tab
                          eventKey="financeiro"
                          title="Financeiro"
                          className="p-3"
                          style={{ fontSize: '0.875rem' }}
                        >
                          <Table size="sm">
                            <thead>
                              <tr>
                                <th style={{ fontSize: '0.875rem' }}>
                                  Data
                                  {isDownloading ? (
                                    <>
                                      <Spinner
                                        size="1rem"
                                        style={{ color: 'black' }}
                                      />
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </th>
                                <th style={{ fontSize: '0.875rem' }}>
                                  Descricao
                                </th>
                                <th
                                  style={{
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  Download
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {dataFiles
                                .filter(arq => arq.folder === 'Financeiro')
                                .sort(
                                  (a, b) =>
                                    parseDateString(b.dataarquivo) -
                                    parseDateString(a.dataarquivo)
                                )
                                .map(row => {
                                  return (
                                    <>
                                      <tr key={row.iFileSystemID}>
                                        <td style={{ fontSize: '0.75rem' }}>
                                          {row.data}
                                        </td>
                                        <td style={{ fontSize: '0.75rem' }}>
                                          {row.FileName}
                                        </td>
                                        <td
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            fontSize: '0.75rem'
                                          }}
                                        >
                                          {' '}
                                          <IconButton
                                            size="sm"
                                            alt="Baixar Arquivo"
                                            aria-label="Baixar Arquivo"
                                            onClick={() =>
                                              getUrlFile(
                                                getOperacaoLocal() ===
                                                  'IMPORTAÇÃO' ||
                                                  getOperacaoLocal() ===
                                                    'EXPORTAÇÃO'
                                                  ? row.iFileSystemID
                                                  : // : operacao[0] === 'T'
                                                    //   ? `${row.DCM_COD}&${row.ADF_COD_SEQ}&${row.FIL_COD}`
                                                    row.IdLogistica_House
                                              )
                                            }
                                            style={{
                                              marginLeft: 'auto',
                                              marginRight: 'auto'
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              icon={faDownload}
                                            />
                                          </IconButton>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                            </tbody>
                          </Table>
                        </Tab>
                      </Tabs>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={() => setModalShowArquivo(false)}
                        size="sm"
                      >
                        Fechar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {/*Modal Numerário Headsoft*/}
                  <Modal
                    show={modalShowCusto}
                    onHide={() => setModalShowCusto(false)}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <Modal.Title id="contained-modal-title-vcenter">
                        Numerário
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Table size="sm">
                        <thead>
                          <tr>
                            <th>Taxa</th>
                            <th>Sigla</th>
                            <th>Valor</th>
                            <th>Fator Conversão</th>
                            <th>Valor Convertido</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataCusto.map(row => {
                            return (
                              <>
                                <tr key={row.Nome}>
                                  <td>{row.Nome}</td>
                                  <td>{row.Sigla}</td>
                                  <td style={{ textAlign: 'end' }}>
                                    {row.Valor_Recebimento_Total}
                                  </td>
                                  <td style={{ textAlign: 'end' }}>
                                    {row.Conversao}
                                  </td>
                                  <td style={{ textAlign: 'end' }}>
                                    {row.ValorTotal}
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                          <tr key="1">
                            <td style={{ fontWeight: 'bold' }} colSpan="4">
                              Total
                            </td>
                            <td style={{ textAlign: 'end' }}>{custoTotal}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={() => setModalShowCusto(false)}
                        size="sm"
                      >
                        Fechar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {/*Modal Custo ilog*/}
                  <Modal
                    show={modalShowCustoiLog}
                    onHide={() => setModalShowCustoiLog(false)}
                    size="xs"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <Modal.Title id="contained-modal-title-vcenter">
                        Custos do Processo
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Table
                        size="xs"
                        style={{
                          borderCollapse: 'collapse',
                          fontSize: '.7rem'
                          // color: '#000'
                        }}
                      >
                        <tr
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: '#e63757',
                            color: '#fff'
                          }}
                        >
                          <td>RELAÇÃO DE DESPESAS</td>
                          <td>VALOR EM R$</td>
                        </tr>
                        <tr
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: '#e63757',
                            color: '#fff'
                          }}
                        >
                          <td>TRIBUTOS</td>
                          <td>
                            {dataCustoTotal
                              .filter(orders => orders.Grupo === 'Tributos')
                              .map(row => {
                                return <>{row.total}</>;
                              })}
                          </td>
                        </tr>
                        {dataCusto
                          .filter(orders => orders.Grupo === 'Tributos')
                          .map(row => {
                            return (
                              <tr key={row.Id}>
                                <td>{row.Descricao}</td>
                                <td>{row.DespesaHistoricoValorAtualizado}</td>
                              </tr>
                            );
                          })}
                        {dataCustoTotal.filter(
                          orders => orders.Grupo === 'Despesas de Embarque'
                        ).length > 0 ? (
                          <>
                            <tr
                              style={{
                                fontWeight: 'bold',
                                backgroundColor: '#e63757',
                                color: '#fff'
                              }}
                            >
                              <td>DESPESAS DE EMBARQUE</td>
                              <td>
                                {dataCustoTotal
                                  .filter(
                                    orders =>
                                      orders.Grupo === 'Despesas de Embarque'
                                  )
                                  .map(row => {
                                    return (
                                      <span
                                        style={{
                                          fontWeight: 'bold',
                                          color: '#fff'
                                        }}
                                        key={row.total}
                                      >
                                        {row.total}
                                      </span>
                                    );
                                  })}
                              </td>
                            </tr>
                          </>
                        ) : (
                          <></>
                        )}

                        {dataCusto
                          .filter(
                            orders => orders.Grupo === 'Despesas de Embarque'
                          )
                          .map(row => {
                            return (
                              <tr key={row.Id}>
                                <td>{row.Descricao}</td>
                                <td>{row.DespesaHistoricoValorAtualizado}</td>
                              </tr>
                            );
                          })}

                        {dataCusto.filter(
                          orders => orders.Grupo === 'Custos Portuários'
                        ).length > 0 ? (
                          <>
                            <tr
                              style={{
                                fontWeight: 'bold',
                                backgroundColor: '#e63757',
                                color: '#fff'
                              }}
                            >
                              <td>CUSTOS PORTUÁRIOS</td>
                              <td>
                                {dataCustoTotal
                                  .filter(
                                    orders =>
                                      orders.Grupo === 'Custos Portuários'
                                  )
                                  .map(row => {
                                    return <>{row.total}</>;
                                  })}
                              </td>
                            </tr>
                            {dataCusto
                              .filter(
                                orders => orders.Grupo === 'Custos Portuários'
                              )
                              .map(row => {
                                return (
                                  <tr key={row.Id}>
                                    <td>{row.Descricao}</td>
                                    <td>
                                      {row.DespesaHistoricoValorAtualizado}
                                    </td>
                                  </tr>
                                );
                              })}
                          </>
                        ) : (
                          <></>
                        )}

                        <tr
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: '#e63757',
                            color: '#fff'
                          }}
                        >
                          <td>SERVIÇOS</td>
                          <td>
                            {dataCustoTotal
                              .filter(orders => orders.Grupo === 'Serviços')
                              .map(row => {
                                return <>{row.total}</>;
                              })}
                          </td>
                        </tr>
                        {dataCusto
                          .filter(orders => orders.Grupo === 'Serviços')
                          .map(row => {
                            return (
                              <tr key={row.Id}>
                                <td>{row.Descricao}</td>
                                <td>{row.DespesaHistoricoValorAtualizado}</td>
                              </tr>
                            );
                          })}

                        <tr
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: '#e63757',
                            color: '#fff'
                          }}
                        >
                          <td>OUTRAS DESPESAS</td>
                          <td>
                            {dataCustoTotal
                              .filter(
                                orders => orders.Grupo === 'Outras Despesas'
                              )
                              .map(row => {
                                return <>{row.total}</>;
                              })}
                          </td>
                        </tr>
                        {dataCusto
                          .filter(orders => orders.Grupo === 'Outras Despesas')
                          .map(row => {
                            return (
                              <tr key={row.Id}>
                                <td>{row.Descricao}</td>
                                <td>{row.DespesaHistoricoValorAtualizado}</td>
                              </tr>
                            );
                          })}
                        <tr rowSpan="2">
                          <td colSpan="1">&nbsp;</td>
                        </tr>
                        <tr style={{ fontWeight: 'bold' }}>
                          <td>Total Geral dos Custos</td>
                          <td>{totalGeralCustos}</td>
                        </tr>
                        <tr style={{ fontWeight: 'bold' }}>
                          <td>Total do Adiantamento Solicitado</td>
                          <td>{totalGeralCustos}</td>
                        </tr>
                        <tr style={{ fontWeight: 'bold' }}>
                          <td>Total do Adiantamento Recebido</td>
                          <td>{totalGeralRecebido}</td>
                        </tr>
                      </Table>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={() => setModalShowCustoiLog(false)}
                        size="sm"
                      >
                        Fechar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {/*Modal Custo Itens ilog*/}
                  <Modal
                    show={modalShowCustoItensiLog}
                    onHide={() => setModalShowCustoItensiLog(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    size="xl"
                  >
                    <Modal.Header>
                      <Modal.Title id="contained-modal-title-vcenter">
                        Custos Nacionalização por Item &nbsp;
                        <IconButton
                          size="sm"
                          alt="Voltar"
                          aria-label="Voltar"
                          className="mt"
                        >
                          <FontAwesomeIcon
                            title="Exportar xlsx"
                            icon={faFileImport}
                            // onClick={() => exportToExcel()} />
                            onClick={() => setShowModal(true)}
                          />
                        </IconButton>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body
                      style={{ maxHeight: '90vh', overflowY: 'auto' }}
                    >
                      <Table
                        size="small"
                        style={{
                          borderCollapse: 'collapse',
                          fontSize: '.7rem',
                          // color: '#000',
                          width: '100%' // A tabela ocupa toda a largura do modal
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              fontWeight: 'bold',
                              backgroundColor: '#e63757',
                              color: '#fff'
                            }}
                          >
                            {/* Cabeçalhos da tabela */}
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                color: '#fff'
                              }}
                            >
                              POSIÇÃO
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '100px',
                                color: '#fff'
                              }}
                            >
                              CÓDIGO
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '500px',
                                color: '#fff'
                              }}
                            >
                              DESCRIÇÃO
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '200px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              EXPORTADOR
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              NCM
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              UN
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              QTD
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              P. LÍQ. UNIT.
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              P. LÍQ. TOTAL
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              VAL. UNIT.
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              FRETE
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              SEGURO
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '150px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              VALOR ADUANEIRO
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '50px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              % II
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              BASE II
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              II
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              % IPI
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              BASE IPI
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              IPI
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              % PIS
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              BASE PIS
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              PIS
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              % COFINS
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '90px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              BASE COFINS
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              COFINS
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '110px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              TAXA SISCOMEX
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              % ICMS
                            </td>
                            <td
                              style={{
                                textAlign: 'center',
                                fontSize: '10px',
                                width: '70px',
                                whiteSpace: 'nowrap',
                                color: '#fff'
                              }}
                            >
                              VAL. TOTAL
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {dataCustoItens.map((row, index) => {
                            return (
                              <>
                                <CustoItens
                                  key={index}
                                  index={index + 1}
                                  custos={row}
                                  subCusto={dataCustoSubItens}
                                />
                              </>
                            );
                          })}
                        </tbody>
                      </Table>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={() => setModalShowCustoItensiLog(false)}
                        size="sm"
                      >
                        Fechar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {/*Modal Selecionar colunas*/}
                  <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                      <Modal.Title>
                        Selecionar Colunas para Exportar
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Col xs={12}>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={selectAll}
                              onChange={handleSelectAllChange}
                              id="selectAll"
                            />
                            <label
                              className="form-check-label ms-2"
                              htmlFor="selectAll"
                            >
                              Selecionar Todas
                            </label>
                          </div>
                        </Col>
                        {Object.keys(selectedColumns).map(column => (
                          <Col xs={6} key={column}>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectedColumns[column]}
                                onChange={() => handleColumnChange(column)}
                                id={column}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor={column}
                              >
                                {columnLabels[column]}
                              </label>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Cancelar
                      </Button>
                      <Button variant="primary" onClick={() => exportToExcel()}>
                        Confirmar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {/*Modal Tracking*/}
                  <Modal
                    show={showModalTracking}
                    onHide={() => setShowModalTracking(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    size="xl"
                  >
                    <div className="relative flex flex-col items-center justify-center h-screen bg-gray-100 p-4">
                      <TrackingMap dataTrackingWorld={dataTrackingWorld} />
                    </div>
                  </Modal>
                </>
              );
            })}
            {operacao[0] === 'F' ? (
              <>
                <ProcessTimeLineFrete
                  dadosProcesso={dataTracking}
                  dadosTransbordo={dadosTransbordo}
                />
              </>
            ) : (
              <>
                <ProcessTimeLine
                  dadosProcesso={dataProcesso}
                  operacao={operacao[0]}
                />
              </>
            )}

            <ProcessFollow dadosFollow={dataFollowUp} />
          </Modal.Body>
        )}
      </Modal>
    </div>
  );
};

KanbanCard.propTypes = {
  colorHeader: PropTypes.string,
  dados: PropTypes.object,
  title: PropTypes.string,
  ordem: PropTypes.number
};

export default KanbanCard;
